import { Pagination, PaginationProps } from "antd";
import { useSearchParams } from "react-router-dom";
import { PAGE } from "../../../utils/constants/common";

const PaginationComponent = ({ total }: { total: number }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const page = Number(searchParams.get("page") || PAGE);
  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (
    current,
    pageSize,
  ) => {
    setSearchParams({ ...searchParams, pageSize: pageSize.toString() });
    const params = new URLSearchParams(searchParams);
    params.set("page", current.toString());
    params.set("pageSize", pageSize.toString());
    setSearchParams(params);
  };
  return (
    <div className="flex items-center gap-2 justify-end h-[46px] pr-6">
      <div className="text-sm text-gray-600">全 {total}件</div>
      <Pagination
        current={page}
        total={total}
        showSizeChanger
        onShowSizeChange={onShowSizeChange}
        onChange={onShowSizeChange}
        pageSize={
          searchParams.get("pageSize")
            ? parseInt(searchParams.get("pageSize")!)
            : 10
        }
      />
    </div>
  );
};

export default PaginationComponent;
